import { useEffect, useState } from "react"
import { MdReportGmailerrorred } from "react-icons/md"
import './Warning.css'
export default function Warning({isActive, handle, title, body}){
  const [active, setActive] = useState(false)
  useEffect(()=>{
    setActive(isActive)
  },[isActive])
  return (<>
  {active?<>
  <div className="backdrop" onClick={()=>{handle()}}>
  </div>
  <div className="warning">
    <span className="text-amber-500"><MdReportGmailerrorred size={150}/></span>
    <span className="text-white font-semibold text-xl text-center max-w-[700px]">{title}</span>
    <button className="light-button mt-4" onClick={()=>{handle()}}>Aceptar</button>
  </div>
  </>:<></>}
  </>)
}